import { BrandButtonWhite } from "./form/buttons";
import "./appheader.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  finishExamSection,
  getAppInfo,
  getUserInfo,
  logoutUser,
  updateCurrentExamData,
  updateLocalExamData,
  userLoggedIn,
} from "./user";

interface Props {
  timer?: boolean;
  checkTimer?: boolean;
  exposeTimer?: ((enabled: boolean) => void) | null;
  home?: boolean;
}

const AppHeader = ({
  timer = true,
  checkTimer = false,
  exposeTimer = null,
  home = false,
}: Props) => {
  const [minutesRemaining, setMinutesRemaining] = useState(0);
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);
  const navigate = useNavigate();
  const userData = getUserInfo();
  const appInfo = getAppInfo();

  const logout = () => {
    logoutUser();
    navigate("/");
  };

  const checkIfExamComplete = () => {
    const currSection = appInfo?.currentExamData?.currentSectionId ? appInfo?.currentExamData?.currentSectionId : 999;
    if (currSection == 4 || currSection == 5) {
      return true;
    } else {
      return false;
    }
  };

  const continueTimeout = async () => {
    if (checkIfExamComplete()) {
      updateCurrentExamData(appInfo?.currentExamData?.examId as number, {
        examComplete: true,
      });
      navigate("/exam-complete", { replace: true });
    } else {
      finishExamSection();
      navigate("/section-end", { replace: true });
    }
  };

  useEffect(() => {
    if (timeRemaining) {
      if(exposeTimer) exposeTimer(minutesRemaining === 0 && secondsRemaining < 2 ? false : true);
    }
    const timer = setInterval(() => {
      if (!timeRemaining && timeRemaining !== 0) return;
      const minutes: number = Math.floor(timeRemaining / 60 / 1000) as number;
      const seconds: number = Math.floor((timeRemaining / 1000) % 60) as number;
      setMinutesRemaining(minutes);
      setSecondsRemaining(seconds);

      if (timeRemaining <= 0) {
        clearInterval(timer);
        continueTimeout();
        return;
      }

      updateLocalExamData({minutesRemaining: timeRemaining,});
      if (timeRemaining % 30000 === 0) {
        updateCurrentExamData(appInfo?.currentExamData?.examId as number, {
          minutesRemaining: timeRemaining,
        });
      }
      setTimeRemaining(timeRemaining - 1000);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [timeRemaining]);

  useEffect(() => {
    if (!userLoggedIn()) {
      navigate("/");
    }

    if ((userData && timer) || checkTimer) {
      let startTime = null;
      if (!timeRemaining) {
        startTime = appInfo?.currentExamData?.minutesRemaining as number;
      } else {
        startTime = timeRemaining;
      }
      setTimeRemaining(startTime);
    }
  }, []);

  return (
    <div className="exam-header">
      {appInfo?.currentExamData?.examStarted && timer && (
        <div className="timer">
          <div className="timer-holder">
            <FontAwesomeIcon icon={faClock} />
            {minutesRemaining < 0 && secondsRemaining < 0 ? (
              <div>... min remaining</div>
            ) : (
              <div>
                {minutesRemaining}:
                {secondsRemaining < 10
                  ? `0${secondsRemaining < 0 ? 0 : secondsRemaining}`
                  : secondsRemaining}{" "}
                min remaining
              </div>
            )}
          </div>
        </div>
      )}
      {home && (
        <>
          <BrandButtonWhite
            onClick={() => navigate("/dashboard", { replace: true })}
            variant="outlined"
            style={{ marginRight: "10px" }}
          >
            <FontAwesomeIcon
              style={{ marginRight: "10px" }}
              icon={faChevronLeft}
            />
            {`DASHBOARD`}
          </BrandButtonWhite>
        </>
      )}
      <BrandButtonWhite onClick={logout} variant="outlined">
        LOGOUT
      </BrandButtonWhite>
    </div>
  );
};

export default AppHeader;
